import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
import DonutChart from '../chart/DonutChart';

const propTypes = {
    className: PropTypes.string,
    avgTimePlayed: PropTypes.number,
    totalCompleted: PropTypes.number,
    timePlayedGraphData: PropTypes.array,
    completionGraphData: PropTypes.array,
};

const defaultProps = {
    className: '',
    avgTimePlayed: 0,
    totalCompleted: 0,
    timePlayedGraphData: [],
    completionGraphData: [],
};

function ShortCourseStatsChart(props) {
    const avgTimePlayed = StringUtil.getTimeStringForMs(props.avgTimePlayed);
    const totalCompleted = parseInt(props.totalCompleted.toFixed(0), 10);
    return (
        <div
            id="charts-course"
            className={props.className}
        >
            <DonutChart
                id="chart-complete-percent-course"
                title={Strings['en'].analytics.overview.short_course.stats_chart.COMPLETED_TITLE}
                columns={props.completionGraphData}
                summaryStat={totalCompleted}
                tooltip={Strings['en'].analytics.overview.short_course.stats_chart.COMPLETED_DESC}
                displayTitleForNoData
            />
            <DonutChart
                id="chart-timeplayed-course"
                title={Strings['en'].analytics.overview.short_course.stats_chart.TIME_PLAYED_TITLE}
                columns={props.timePlayedGraphData}
                summaryStat={avgTimePlayed}
                tooltip={Strings['en'].analytics.overview.short_course.stats_chart.TIME_PLAYED_DESC}
                displayTitleForNoData
            />
        </div>
    );
}

ShortCourseStatsChart.propTypes = propTypes;
ShortCourseStatsChart.defaultProps = defaultProps;

export default ShortCourseStatsChart;